"use strict";
/**
 * Signature of the shared whole-dollar split (TRD §11.3).
 * HAN-656 implements `SplitStageAmount` and `SplitSchedule`.
 * These examples are the contract both that helper and the Checker headline use.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SPLIT_SCHEDULE_EXAMPLES = exports.SPLIT_STAGE_EXAMPLES = exports.splitSchedule = exports.splitStageAmount = exports.PAYMENT_ROLES = void 0;
exports.PAYMENT_ROLES = ["deposit", "later"];
/** A deposit is protected in full. A later payment's protected half rounds up. A 0 amount contributes nothing. */
const splitStageAmount = (stage) => {
    const amount = Math.max(0, Math.trunc(Number(stage.amount) || 0));
    if (amount === 0) {
        return { protectedAmount: 0, toIdAmount: 0 };
    }
    if (stage.role === "deposit") {
        return { protectedAmount: amount, toIdAmount: 0 };
    }
    const protectedAmount = Math.ceil(amount / 2);
    return { protectedAmount, toIdAmount: amount - protectedAmount };
};
exports.splitStageAmount = splitStageAmount;
/**
 * Allocate whole-dollar stage amounts from percents (last stage absorbs), then split each stage.
 * `protectedRemaining` is protected amount on non-deposit stages only.
 */
const splitSchedule = (contractValue, stages) => {
    const value = Math.max(0, Math.trunc(Number(contractValue) || 0));
    const n = stages.length;
    if (n === 0) {
        return { stageAmounts: [], protectedTotal: 0, protectedRemaining: 0, stages: [] };
    }
    const stageAmounts = stages.map((stage) => {
        const pct = Number(stage.pct) || 0;
        if (pct === 0) {
            return 0;
        }
        return Math.round((value * pct) / 100);
    });
    if (value > 0) {
        let diff = value - stageAmounts.reduce((sum, amount) => sum + amount, 0);
        // Last non-zero-% stage absorbs. Never put remainder on a 0% stage (can go negative).
        for (let i = n - 1; i >= 0 && diff !== 0; i--) {
            if ((Number(stages[i].pct) || 0) === 0) {
                continue;
            }
            const next = stageAmounts[i] + diff;
            if (next < 0) {
                diff = next;
                stageAmounts[i] = 0;
            }
            else {
                stageAmounts[i] = next;
                diff = 0;
            }
        }
    }
    else {
        for (let i = 0; i < n; i++) {
            stageAmounts[i] = 0;
        }
    }
    const splitStages = [];
    let protectedTotal = 0;
    let protectedRemaining = 0;
    for (let i = 0; i < n; i++) {
        const result = (0, exports.splitStageAmount)({ amount: stageAmounts[i], role: stages[i].role });
        splitStages.push(result);
        protectedTotal += result.protectedAmount;
        if (stages[i].role !== "deposit") {
            protectedRemaining += result.protectedAmount;
        }
    }
    return { stageAmounts, protectedTotal, protectedRemaining, stages: splitStages };
};
exports.splitSchedule = splitSchedule;
exports.SPLIT_STAGE_EXAMPLES = [
    {
        name: "later-11667",
        input: { amount: 11667, role: "later" },
        expected: { protectedAmount: 5834, toIdAmount: 5833 },
    },
];
exports.SPLIT_SCHEDULE_EXAMPLES = [
    {
        name: "visualiser-100000",
        contractValue: 100000,
        stages: [
            { pct: 20, role: "deposit" },
            { pct: 30, role: "later" },
            { pct: 40, role: "later" },
            { pct: 10, role: "later" },
        ],
        expected: {
            stageAmounts: [20000, 30000, 40000, 10000],
            protectedTotal: 60000,
            protectedRemaining: 40000,
            stages: [
                { protectedAmount: 20000, toIdAmount: 0 },
                { protectedAmount: 15000, toIdAmount: 15000 },
                { protectedAmount: 20000, toIdAmount: 20000 },
                { protectedAmount: 5000, toIdAmount: 5000 },
            ],
        },
    },
    {
        name: "checker-60000",
        contractValue: 60000,
        stages: [
            { pct: 30, role: "deposit" },
            { pct: 40, role: "later" },
            { pct: 25, role: "later" },
            { pct: 5, role: "later" },
        ],
        expected: {
            stageAmounts: [18000, 24000, 15000, 3000],
            protectedTotal: 39000,
            protectedRemaining: 21000,
            stages: [
                { protectedAmount: 18000, toIdAmount: 0 },
                { protectedAmount: 12000, toIdAmount: 12000 },
                { protectedAmount: 7500, toIdAmount: 7500 },
                { protectedAmount: 1500, toIdAmount: 1500 },
            ],
        },
    },
];
